declare var System;
System.config({
    map: {
        app: 'src/ts/Main'
    }
});